import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password show/hide toggle for the auth surface.
 * Rendered as a Field `rightAdornment`. type="button" + tabIndex={-1} keep it
 * out of the form's submit/tab flow.
 */
const ToggleVisibility = ({ shown, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    tabIndex={-1}
    aria-label={shown ? 'Hide password' : 'Show password'}
    className="grid h-8 w-8 place-items-center rounded text-slate-400 hover:text-slate-600"
  >
    {shown ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
  </button>
);

export default ToggleVisibility;
